export default __webpack_public_path__ + "static/media/state-change_confirm-up.7842dcde.wav";